import * as React from 'react';
import { Box, Button, Typography, IconButton, Menu, MenuItem } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import dashboard from "../Assets/dash/dashboard.png";
import delivery from "../Assets/dash/delivery.svg";
import order from "../Assets/dash/order.svg";
import product from "../Assets/dash/product.svg";
import user from "../Assets/dash/user.svg";
import vendorIcon from "../Assets/prime/sidebar/Vendor.svg";
import sellIcon from "../Assets/dash/Sell.svg";
import { useDispatch, useSelector } from "react-redux";
import { updatepageName } from "../Redux/page";
import { useNavigate, useLocation } from 'react-router-dom';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
export function Sidebar() {
  const dispatch = useDispatch();
  const pagename = useSelector(state => state.page.pageName);
  const inventory = useSelector(state => state.inventory.inventory);
  const location = useLocation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [subMenuAnchorEl, setSubMenuAnchorEl] = React.useState(null);
  const [productMenuAnchor, setProductMenuAnchor] = React.useState(null);
  const [settingsMenuAnchor, setSettingsMenuAnchor] = React.useState(null);
  const [deliveryMenuAnchor, setDeliveryMenuAnchor] = React.useState(null);
  const menuOpen = Boolean(anchorEl);
  const subMenuOpen = Boolean(subMenuAnchorEl);
  const productMenuOpen = Boolean(productMenuAnchor);
  const settingsMenuOpen = Boolean(settingsMenuAnchor);
  const deliveryMenuOpen = Boolean(deliveryMenuAnchor);
  const navigate = useNavigate()
  const user_role = localStorage.getItem('role');
  const isCashier = user_role === 'cashier';

  let currentOnboardingStatus = 'draft';
  try {
    const selectedHubRaw = localStorage.getItem('selected_hub');
    if (selectedHubRaw && inventory && Array.isArray(inventory)) {
      let selectedHubId = null;

      try {
        const parsed = JSON.parse(selectedHubRaw);
        if (Array.isArray(parsed) && parsed.length > 0) {
          selectedHubId = typeof parsed[0] === 'number' ? parsed[0] : parseInt(parsed[0], 10);
        } else if (typeof parsed === 'number') {
          selectedHubId = parsed;
        } else if (typeof parsed === 'string') {
          selectedHubId = parseInt(parsed, 10);
        }
      } catch (e) {
        selectedHubId = parseInt(selectedHubRaw, 10);
      }

      if (selectedHubId && !isNaN(selectedHubId)) {
        const currentHub = inventory.find(
          (hub) =>
            hub &&
            (hub.value === selectedHubId ||
              String(hub.value) === String(selectedHubId))
        );
        if (currentHub && currentHub.onboarding_status) {
          currentOnboardingStatus = currentHub.onboarding_status;
        }
      }
    }
  } catch (e) {
  }

  // Merchant access helpers
  const isMerchant = user_role === 'merchant';
  const isMerchantWithPublishedHub = isMerchant && currentOnboardingStatus === 'published';
  const isMerchantRestricted = isMerchant && !isMerchantWithPublishedHub;
  const canAccessSettings = ['super_admin', 'admin', 'supervisor'].includes(user_role) || isMerchantWithPublishedHub;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSubMenuAnchorEl(null);
  };

  const handleSubMenuOpen = (event) => {
    setSubMenuAnchorEl(event.currentTarget);
  };

  const handleSubMenuClose = () => {
    setSubMenuAnchorEl(null);
  };

  const handleProductMenuOpen = (event) => {
    setProductMenuAnchor(event.currentTarget);
  };

  const handleProductMenuClose = () => {
    setProductMenuAnchor(null);
  };

  const handleSettingsMenuOpen = (event) => {
    setSettingsMenuAnchor(event.currentTarget);
  };

  const handleSettingsMenuClose = () => {
    setSettingsMenuAnchor(null);
  };

  const handleDeliveryMenuOpen = (event) => {
    setDeliveryMenuAnchor(event.currentTarget);
  };

  const handleDeliveryMenuClose = () => {
    setDeliveryMenuAnchor(null);
  };

  // Role-based menu items
  const getEditItems = () => {
    const allItems = [
      {
        label: 'Product Details',
        command: () => {
          navigate("/home/product_details")
          dispatch(updatepageName("product_details"))
        }
      },
      {
        label: 'Inventory',
        command: () => {
          navigate("/home/inventory")
          dispatch(updatepageName("inventory"))
        }
      },
      {
        label: 'Campaign',
        command: () => {
          navigate("/home/campaign")
          dispatch(updatepageName("campaign"))
        }
      },
      {
        label: 'Campaign push notification',
        command: () => {
          navigate("/home/Campaign_push_notification")
          dispatch(updatepageName("Campaign_push_notofication"))
        }
      },
      {
        label: 'Product Banner',
        command: () => {
          navigate("/home/product_banner")
        }
      },
      {
        label: 'Home Banner',
        command: () => {
          navigate("/home/home_banner")
        }
      }
    ];

    // Filter based on role
    switch (user_role) {
      case 'super_admin':
        return allItems; // Super Admin sees everything
      case 'admin':
        return allItems; // Admin sees everything
      case 'merchant':
        // Merchants only see product menus once their hub is published
        return isMerchantWithPublishedHub ? allItems : [];
      case 'supervisor':
        const assignedHubs = JSON.parse(localStorage.getItem('hub') || '[]');
        const selectedFranchiseId = localStorage.getItem('selected_franchise_id');
        const isFoodFixSupervisor = selectedFranchiseId && parseInt(selectedFranchiseId) === 2;

        const hasFoodFixHub = inventory && inventory.some(hub =>
          assignedHubs.includes(hub.value) && hub.franchise_id === 2
        );
        
        const canAccessCampaign = isFoodFixSupervisor || hasFoodFixHub;

        console.log('Sidebar - Supervisor Debug:', {
          user_role,
          assignedHubs,
          selectedFranchiseId,
          isFoodFixSupervisor,
          hasFoodFixHub,
          canAccessCampaign,
          inventory: inventory?.map(hub => ({ id: hub.value, name: hub.name, franchise_id: hub.franchise_id }))
        });

        if (canAccessCampaign) {
          return allItems;
        } else {
          return allItems.filter(item =>
            item.label !== 'Campaign push notification'
          );
        }
      case 'customer_engagement_admin':
        return allItems.filter(item =>
          ['Product Details', 'Inventory', 'Campaign', 'Campaign push notification', 'Product Banner'].includes(item.label)
        );
      default:
        return [];
    }
  };

  const getSettingMenu = () => {
    const allItems = [
      {
        label: 'Category Settings',
        command: () => {
          navigate("/home/category")
          dispatch(updatepageName("category"))
        }
      },
      {
        label: 'Sub Category Settings',
        command: () => {
          navigate("/home/sub_category")
          dispatch(updatepageName("sub_category"))
        }
      },
      {
        label: 'Profile Settings',
        command: () => {
          navigate("/home/profile_settings")
          dispatch(updatepageName("profile_settings"))
        }
      },
      {
        label: 'General',
        command: () => {
          navigate("/home/general")
          dispatch(updatepageName("general"))
        }
      },
      {
        label: 'App Version Control',
        command: () => {
          navigate("/home/app_version_control")
          dispatch(updatepageName("app_version_control"))
        }
      },
      {
        label: 'Launch Screen',
        command: () => {
          navigate("/home/launch_screen")
          dispatch(updatepageName("launch_screen"))
        }
      },
      {
        label: 'Landing Page Ads',
        command: () => {
          navigate("/home/landing_page_ads")
          dispatch(updatepageName("landing_page_ads"))
        }
      },
      {
        label: "Add Instruction",
        command: () => {
          navigate('/home/addinstruction')
          dispatch(updatepageName("addinstruction"))
        }
      }
    ];

    // Filter based on role
    switch (user_role) {
      case 'super_admin':
        return allItems; // Super Admin sees everything
      case 'admin':
        return allItems; // Admin sees everything
      case 'merchant':
        // Merchants only see Category and Sub Category settings once their hub is published
        return isMerchantWithPublishedHub ? allItems.filter(item =>
          item.label === 'Category Settings' || item.label === 'Sub Category Settings'
        ) : [];
      case 'supervisor':
        return allItems.filter(item =>
          item.label !== 'App Version Control' // Hub Supervisor cannot control app version settings
        );
      case 'customer_engagement_admin':
        return []; // Customer Engagement Admin doesn't see settings
      default:
        return [];
    }
  };

  const editItems = getEditItems();
  const settingMenu = getSettingMenu();

  const logout = () => {
    localStorage.clear()
    localStorage.removeItem('hub');
    navigate("/")
  }

  // Cashiers and users do not need the sidebar
  if (user_role === 'cashier' || user_role === 'user') {
    return null;
  }


  return (
    <Box sx={{ display: 'block', position: { xs: "absolute", md: "sticky" }, top: { xs: 16, md: "0" }, right: { xs: 20, md: "initial" } }}>
      {/* Desktop Sidebar */}
      <Box
        sx={{
          display: { xs: 'none', md: 'flex' },
          width: "94px",
          height: "710px",
          padding: "24px 8px",
          backgroundColor: "var(--p-sidebar-background)",
          marginLeft: "20px",
          marginTop: "20px",
          borderRadius: "16px",
          // boxShadow: "0px 0px 25px 0px #0000001A",
          flexDirection: "column",
          gap: "18px",
          position: "sticky",
          top: "24px"
        }}
      >
        {/* <Button 
          sx={{ 
            display: "flex", 
            flexDirection: "column", 
            gap: "2px",
            opacity: isMerchantRestricted ? 0.5 : 1,
            cursor: isMerchantRestricted ? "not-allowed" : "pointer",
            pointerEvents: isMerchantRestricted ? "none" : "auto"
          }} 
          onClick={() => !isMerchantRestricted && (navigate("/home/dashboard"), dispatch(updatepageName("dashboard")))}
          disabled={isMerchantRestricted}
        >
          <Box component="img" src={dashboard} sx={{ color: "green" }} />
          <Typography sx={{ fontSize: "9px", color: pagename === "dashboard" ? "primary.main" : "text.secondary", textAlign: "center" }}>
            Dashboard
          </Typography>
        </Button> */}

        <Button
          sx={{ display: "flex", flexDirection: "column", gap: "2px" }}
          onClick={() => {
            if (isMerchant) {
              // For merchants, navigate directly to their hub page
              const selectedHub = localStorage.getItem('selected_hub');
              let hubId = null;

              if (selectedHub) {
                try {
                  // Try parsing as JSON first (in case it's stored as array)
                  const parsed = JSON.parse(selectedHub);
                  if (Array.isArray(parsed) && parsed.length > 0) {
                    hubId = typeof parsed[0] === 'number' ? parsed[0] : parseInt(parsed[0], 10);
                  } else if (typeof parsed === 'number') {
                    hubId = parsed;
                  } else if (typeof parsed === 'string') {
                    hubId = parseInt(parsed, 10);
                  }
                } catch (e) {
                  // Not JSON, try as number string
                  hubId = parseInt(selectedHub, 10);
                }
              }

              if (hubId && !isNaN(hubId)) {
                navigate(`/home/add_hub/${hubId}`);
                dispatch(updatepageName("add_hub"));
              } else {
                // If no hub ID found, navigate to add_hub without ID (will fetch hub)
                navigate("/home/add_hub");
                dispatch(updatepageName("add_hub"));
              }
            } else {
              navigate("/home/vendor_management");
              dispatch(updatepageName("vendor_management"));
            }
          }}
        >
          <Box
            component="img"
            src={vendorIcon}
            sx={{
              filter: (pagename === "vendor_management" || pagename === "add_hub" || location.pathname.includes("vendor_management") || location.pathname.includes("add_hub"))
                ? "none"
                : "grayscale(100%) opacity(0.5)",
              transition: "filter 0.2s ease"
            }}
          />
          <Typography sx={{ fontSize: "9px", color: (pagename === "vendor_management" || pagename === "add_hub" || location.pathname.includes("vendor_management") || location.pathname.includes("add_hub")) ? "primary.main" : "text.secondary", textAlign: "center" }}>
            Vendor Management
          </Typography>
        </Button>

        {isMerchant && (
          <Button
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "2px",
              opacity: isMerchantRestricted ? 0.5 : 1,
              cursor: isMerchantRestricted ? "not-allowed" : "pointer",
              pointerEvents: isMerchantRestricted ? "none" : "auto"
            }}
            onClick={() => !isMerchantRestricted && (navigate("/home/suppliers"), dispatch(updatepageName("suppliers")))}
            disabled={isMerchantRestricted}
          >
            <Box
              component="img"
              src={vendorIcon}
              sx={{
                filter: (pagename === "suppliers" || location.pathname.includes("suppliers"))
                  ? "none"
                  : "grayscale(100%) opacity(0.5)",
                transition: "filter 0.2s ease"
              }}
            />
            <Typography sx={{ fontSize: "9px", color: (pagename === "suppliers" || location.pathname.includes("suppliers")) ? "primary.main" : "text.secondary", textAlign: "center" }}>
              Suppliers
            </Typography>
          </Button>
        )}

        <Box className="productManagement" sx={{ position: "relative" }}>
          <Button
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "2px",
              opacity: isMerchantRestricted ? 0.5 : 1,
              cursor: isMerchantRestricted ? "not-allowed" : "pointer",
              pointerEvents: isMerchantRestricted ? "none" : "auto"
            }}
            onClick={!isMerchantRestricted ? handleProductMenuOpen : undefined}
            disabled={isMerchantRestricted}
            aria-haspopup="true"
            aria-controls={productMenuOpen ? 'product-menu' : undefined}
            aria-expanded={productMenuOpen ? 'true' : undefined}
          >
            <Box
              component="img"
              src={product}
              sx={{
                filter: (pagename === "product_details" || pagename === "inventory" || pagename === "inventoryBatchList" || pagename === "BatchHistory" || pagename === "campaign" || pagename === "Campaign_push_notification" || pagename === "product_banner")
                  ? "none"
                  : "grayscale(100%) opacity(0.5)",
                transition: "filter 0.2s ease"
              }}
            />
            <Typography sx={{ fontSize: "9px", color: pagename === "product_details" || pagename === "inventory" || pagename === "inventoryBatchList" || pagename === "BatchHistory" || pagename === "campaign" || pagename === "Campaign_push_notification" || pagename === "product_banner" ? "primary.main" : "text.secondary", textAlign: "center" }}>
              Product Management
            </Typography>
          </Button>
          <Menu
            id="product-menu"
            anchorEl={productMenuAnchor}
            open={productMenuOpen}
            onClose={handleProductMenuClose}
            anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
            transformOrigin={{ vertical: 'center', horizontal: 'left' }}
          >
            {editItems.map((item) => (
              <MenuItem
                key={item.label}
                onClick={() => {
                  if (!isMerchantRestricted) {
                    item.command();
                    handleProductMenuClose();
                  }
                }}
                disabled={isMerchantRestricted}
                sx={{ opacity: isMerchantRestricted ? 0.5 : 1 }}
                selected={pagename === item?.pageName}
              >
                {item.label}
              </MenuItem>
            ))}
          </Menu>
        </Box>

        <Button
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "2px",
            opacity: isMerchantRestricted ? 0.5 : 1,
            cursor: isMerchantRestricted ? "not-allowed" : "pointer",
            pointerEvents: isMerchantRestricted ? "none" : "auto"
          }}
          onClick={() => !isMerchantRestricted && (navigate("/home/order_management"), dispatch(updatepageName("order_management")))}
          disabled={isMerchantRestricted}
        >
          <Box
            component="img"
            src={order}
            sx={{
              filter: pagename === "order_management"
                ? "none"
                : "grayscale(100%) opacity(0.5)",
              transition: "filter 0.2s ease"
            }}
          />
          <Typography sx={{ fontSize: "9px", color: pagename === "order_management" ? "primary.main" : "text.secondary", textAlign: "center" }}>
            Order Management
          </Typography>
        </Button>

        <Button
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "2px",
            opacity: isMerchantRestricted ? 0.5 : 1,
            cursor: isMerchantRestricted ? "not-allowed" : "pointer",
            pointerEvents: isMerchantRestricted ? "none" : "auto"
          }}
          onClick={() => !isMerchantRestricted && (navigate("/home/pos_billing"), dispatch(updatepageName("pos_billing")))}
          disabled={isMerchantRestricted}
        >
          <Box
            component="img"
            src={sellIcon}
            sx={{
              filter: (pagename === "pos_billing" || location.pathname.includes("pos_billing"))
                ? "none"
                : "grayscale(100%) opacity(0.5)",
              transition: "filter 0.2s ease"
            }}
          />
          <Typography sx={{ fontSize: "9px", color: pagename === "pos_billing" || location.pathname.includes("pos_billing") ? "primary.main" : "text.secondary", textAlign: "center" }}>
            POS Billing
          </Typography>
        </Button>

        <Box className="deliveryManagement" sx={{ position: "relative" }}>
          <Button
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "2px",
              opacity: isMerchantRestricted ? 0.5 : 1,
              cursor: isMerchantRestricted ? "not-allowed" : "pointer",
              pointerEvents: isMerchantRestricted ? "none" : "auto"
            }}
            onClick={!isMerchantRestricted ? handleDeliveryMenuOpen : undefined}
            disabled={isMerchantRestricted}
            aria-haspopup="true"
            aria-controls={deliveryMenuOpen ? 'delivery-menu' : undefined}
            aria-expanded={deliveryMenuOpen ? 'true' : undefined}
          >
            <Box
              component="img"
              src={delivery}
              sx={{
                filter: (pagename === "delivery_management" || pagename === "weekly_delivery_slots")
                  ? "none"
                  : "grayscale(100%) opacity(0.5)",
                transition: "filter 0.2s ease"
              }}
            />
            <Typography
              sx={{
                fontSize: "9px",
                color:
                  pagename === "delivery_management" ||
                    pagename === "weekly_delivery_slots"
                    ? "primary.main"
                    : "text.secondary",
                textAlign: "center",
              }}
            >
              Delivery Management
            </Typography>
          </Button>
          <Menu
            id="delivery-menu"
            anchorEl={deliveryMenuAnchor}
            open={deliveryMenuOpen}
            onClose={handleDeliveryMenuClose}
            anchorOrigin={{ vertical: "center", horizontal: "right" }}
            transformOrigin={{ vertical: "center", horizontal: "left" }}
          >
            {user_role !== 'merchant' && (
              <MenuItem
                onClick={() => {
                  if (!isMerchantRestricted) {
                    navigate("/home/delivery_management");
                    dispatch(updatepageName("delivery_management"));
                    handleDeliveryMenuClose();
                  }
                }}
                disabled={isMerchantRestricted}
                sx={{ opacity: isMerchantRestricted ? 0.5 : 1 }}
              >
                Delivery Partners
              </MenuItem>
            )}
            <MenuItem
              onClick={() => {
                if (!isMerchantRestricted) {
                  navigate("/home/weekly_delivery_slots");
                  dispatch(updatepageName("weekly_delivery_slots"));
                  handleDeliveryMenuClose();
                }
              }}
              disabled={isMerchantRestricted}
              sx={{ opacity: isMerchantRestricted ? 0.5 : 1 }}
            >
              Delivery / Pick up slots
            </MenuItem>
          </Menu>
        </Box>

        {/* <Button 
          sx={{ 
            display: "flex", 
            flexDirection: "column", 
            gap: "2px",
            opacity: isMerchantRestricted ? 0.5 : 1,
            cursor: isMerchantRestricted ? "not-allowed" : "pointer",
            pointerEvents: isMerchantRestricted ? "none" : "auto"
          }} 
          onClick={() => !isMerchantRestricted && (navigate("/home/user_management"), dispatch(updatepageName("user_management")))}
          disabled={isMerchantRestricted}
        >
          <Box component="img" src={user} />
          <Typography sx={{ fontSize: "9px", color: pagename === "user_management" ? "primary.main" : "text.secondary", textAlign: "center" }}>
            User Management
          </Typography>
        </Button> */}

        {/* <Button 
          sx={{ 
            display: "flex", 
            flexDirection: "column", 
            gap: "2px",
            opacity: isMerchantRestricted ? 0.5 : 1,
            cursor: isMerchantRestricted ? "not-allowed" : "pointer",
            pointerEvents: isMerchantRestricted ? "none" : "auto"
          }} 
          onClick={() => !isMerchantRestricted && (navigate("/home/offer_management"), dispatch(updatepageName("offer_management")))}
          disabled={isMerchantRestricted}
        >
          <Box component="img" src={order} />
          <Typography sx={{ fontSize: "9px", color: pagename === "offer_management" ? "primary.main" : "text.secondary", textAlign: "center" }}>
            Offer Management
          </Typography>
        </Button> */}

        {canAccessSettings && (
          <Box className="productManagement" sx={{ position: "relative", display: "flex", justifyContent: "center" }}>
            <Button
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "2px",
                opacity: isMerchantRestricted ? 0.5 : 1,
                cursor: isMerchantRestricted ? "not-allowed" : "pointer",
                pointerEvents: isMerchantRestricted ? "none" : "auto"
              }}
              onClick={!isMerchantRestricted ? handleSettingsMenuOpen : undefined}
              disabled={isMerchantRestricted}
              aria-haspopup="true"
              aria-controls={settingsMenuOpen ? 'settings-menu' : undefined}
              aria-expanded={settingsMenuOpen ? 'true' : undefined}
            >
              <SettingsOutlinedIcon
                sx={{
                  color: (pagename === "category" || pagename === "sub_category" || pagename === "general" || pagename === "profile_settings" || pagename === "app_version_control" || pagename === "launch_screen" || pagename === "landing_page_ads" || pagename === "addinstruction")
                    ? "primary.main"
                    : "text.secondary",
                  transition: "color 0.2s ease"
                }}
              />
              <Typography sx={{ fontSize: "9px", color: pagename === "category" || pagename === "sub_category" || pagename === "general" || pagename === "profile_settings" || pagename === "app_version_control" || pagename === "launch_screen" || pagename === "landing_page_ads" || pagename === "addinstruction" ? "primary.main" : "text.secondary", textAlign: "center" }}>
                Settings
              </Typography>
            </Button>
            <Menu
              id="settings-menu"
              anchorEl={settingsMenuAnchor}
              open={settingsMenuOpen}
              onClose={handleSettingsMenuClose}
              anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
              transformOrigin={{ vertical: 'center', horizontal: 'left' }}
            >
              {settingMenu.map((item) => (
                <MenuItem
                  key={item.label}
                  onClick={() => {
                    if (!isMerchantRestricted) {
                      item.command();
                      handleSettingsMenuClose();
                    }
                  }}
                  disabled={isMerchantRestricted}
                  sx={{ opacity: isMerchantRestricted ? 0.5 : 1 }}
                >
                  {item.label}
                </MenuItem>
              ))}
            </Menu>
          </Box>
        )}

        <Button
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "2px",
            opacity: isMerchantRestricted ? 0.5 : 1,
            cursor: isMerchantRestricted ? "not-allowed" : "pointer",
            pointerEvents: isMerchantRestricted ? "none" : "auto"
          }}
          onClick={() => !isMerchantRestricted && logout()}
          disabled={isMerchantRestricted}
        >
          <Box
            component="img"
            src={user}
            sx={{
              filter: "grayscale(100%) opacity(0.5)",
              transition: "filter 0.2s ease"
            }}
          />
          <Typography sx={{ fontSize: "9px", color: "text.secondary", textAlign: "center" }}>
            Logout
          </Typography>
        </Button>
      </Box>

      {/* Mobile Hamburger Menu */}
      <Box sx={{ display: { xs: 'block', md: 'none' } }}>
        <IconButton
          id="compact-menu-button"
          aria-controls={menuOpen ? 'compact-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={menuOpen ? 'true' : undefined}
          onClick={handleClick}
          color="inherit"
        >
          <MenuIcon />
        </IconButton>

        <Menu
          id="compact-menu"
          anchorEl={anchorEl}
          open={menuOpen}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'compact-menu-button',
          }}
        >
          <Box >
            {/* <Typography variant="h6" sx={{ mb: 1 }}>Menu</Typography>onClick={() => navigate("/home/dashboard")) */}
            {/* <MenuItem 
              onClick={() => { if (!isMerchantRestricted) { navigate("/home/dashboard"); dispatch(updatepageName("dashboard")); handleClose(); } }}
              disabled={isMerchantRestricted}
              sx={{ opacity: isMerchantRestricted ? 0.5 : 1 }}
            >
              Dashboard
            </MenuItem> */}
            <MenuItem
              onClick={() => {
                if (isMerchant) {
                  // For merchants, navigate directly to their hub page
                  const selectedHub = localStorage.getItem('selected_hub');
                  let hubId = null;

                  if (selectedHub) {
                    try {
                      // Try parsing as JSON first (in case it's stored as array)
                      const parsed = JSON.parse(selectedHub);
                      if (Array.isArray(parsed) && parsed.length > 0) {
                        hubId = typeof parsed[0] === 'number' ? parsed[0] : parseInt(parsed[0], 10);
                      } else if (typeof parsed === 'number') {
                        hubId = parsed;
                      } else if (typeof parsed === 'string') {
                        hubId = parseInt(parsed, 10);
                      }
                    } catch (e) {
                      // Not JSON, try as number string
                      hubId = parseInt(selectedHub, 10);
                    }
                  }

                  if (hubId && !isNaN(hubId)) {
                    navigate(`/home/add_hub/${hubId}`);
                    dispatch(updatepageName("add_hub"));
                  } else {
                    // If no hub ID found, navigate to add_hub without ID (will fetch hub)
                    navigate("/home/add_hub");
                    dispatch(updatepageName("add_hub"));
                  }
                } else {
                  navigate("/home/vendor_management");
                  dispatch(updatepageName("vendor_management"));
                }
                handleClose();
              }}
            >
              Vendor Management
            </MenuItem>
            {isMerchant && (
              <MenuItem
                onClick={() => {
                  if (!isMerchantRestricted) {
                    navigate("/home/suppliers");
                    dispatch(updatepageName("suppliers"));
                    handleClose();
                  }
                }}
                disabled={isMerchantRestricted}
                sx={{ opacity: isMerchantRestricted ? 0.5 : 1 }}
              >
                Suppliers
              </MenuItem>
            )}
            {/* Product Management with Submenu */}
            <MenuItem
              onClick={!isMerchantRestricted ? handleSubMenuOpen : undefined}
              disabled={isMerchantRestricted}
              sx={{ opacity: isMerchantRestricted ? 0.5 : 1 }}
              aria-haspopup="true"
              aria-controls={subMenuOpen ? 'product-submenu' : undefined}
            >
              Product Management
            </MenuItem>

            {/* Submenu for Product Management */}
            <Menu
              id="product-submenu"
              anchorEl={subMenuAnchorEl}
              open={subMenuOpen}
              onClose={handleSubMenuClose}
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            >
              {user_role === 'customer_engagement_admin' ? (
                // Customer Engagement Admin sees Product Details, Campaign, Campaign Push Notification, and Product Banner
                <>
                  <MenuItem
                    onClick={() => { if (!isMerchantRestricted) { navigate("/home/product_details"); dispatch(updatepageName("product_details")); handleClose(); } }}
                    disabled={isMerchantRestricted}
                    sx={{ opacity: isMerchantRestricted ? 0.5 : 1 }}
                  >
                    Product Details
                  </MenuItem>
                  <MenuItem
                    onClick={() => { if (!isMerchantRestricted) { navigate("/home/campaign"); dispatch(updatepageName("campaign")); handleClose(); } }}
                    disabled={isMerchantRestricted}
                    sx={{ opacity: isMerchantRestricted ? 0.5 : 1 }}
                  >
                    Campaign
                  </MenuItem>
                  <MenuItem
                    onClick={() => { if (!isMerchantRestricted) { navigate("/home/Campaign_push_notification"); dispatch(updatepageName("Campaign_push_notofication")); handleClose(); } }}
                    disabled={isMerchantRestricted}
                    sx={{ opacity: isMerchantRestricted ? 0.5 : 1 }}
                  >
                    Campaign Push Notification
                  </MenuItem>
                  <MenuItem
                    onClick={() => { if (!isMerchantRestricted) { navigate("/home/product_banner"); dispatch(updatepageName("product_banner")); handleClose(); } }}
                    disabled={isMerchantRestricted}
                    sx={{ opacity: isMerchantRestricted ? 0.5 : 1 }}
                  >
                    Product Banner
                  </MenuItem>
                </>
              ) : (
                // Other roles see all product management options
                <>
                  <MenuItem
                    onClick={() => { if (!isMerchantRestricted) { navigate("/home/product_details"); dispatch(updatepageName("product_details")); handleClose(); } }}
                    disabled={isMerchantRestricted}
                    sx={{ opacity: isMerchantRestricted ? 0.5 : 1 }}
                  >
                    Product Details
                  </MenuItem>
                  <MenuItem
                    onClick={() => { if (!isMerchantRestricted) { navigate("/home/inventory"); dispatch(updatepageName("inventory")); handleClose(); } }}
                    disabled={isMerchantRestricted}
                    sx={{ opacity: isMerchantRestricted ? 0.5 : 1 }}
                  >
                    Inventory
                  </MenuItem>
                  <MenuItem
                    onClick={() => { if (!isMerchantRestricted) { navigate("/home/campaign"); dispatch(updatepageName("campaign")); handleClose(); } }}
                    disabled={isMerchantRestricted}
                    sx={{ opacity: isMerchantRestricted ? 0.5 : 1 }}
                  >
                    Campaign
                  </MenuItem>
                  {user_role !== 'supervisor' && (
                    <MenuItem
                      onClick={() => { if (!isMerchantRestricted) { navigate("/home/Campaign_push_notification"); dispatch(updatepageName("Campaign_push_notofication")); handleClose(); } }}
                      disabled={isMerchantRestricted}
                      sx={{ opacity: isMerchantRestricted ? 0.5 : 1 }}
                    >
                      Campaign Push Notification
                    </MenuItem>
                  )}
                </>
              )}
            </Menu>
            <MenuItem
              onClick={() => { if (!isMerchantRestricted) { navigate("/home/order_management"); dispatch(updatepageName("order_management")); handleClose(); } }}
              disabled={isMerchantRestricted}
              sx={{ opacity: isMerchantRestricted ? 0.5 : 1 }}
            >
              Order Management
            </MenuItem>
            <MenuItem
              onClick={() => { if (!isMerchantRestricted) { navigate("/home/pos_billing"); dispatch(updatepageName("pos_billing")); handleClose(); } }}
              disabled={isMerchantRestricted}
              sx={{ opacity: isMerchantRestricted ? 0.5 : 1 }}
            >
              POS Billing
            </MenuItem>
            {user_role !== 'merchant' && (
              <MenuItem
                onClick={() => { if (!isMerchantRestricted) { navigate("/home/delivery_management"); dispatch(updatepageName("delivery_management")); handleClose(); } }}
                disabled={isMerchantRestricted}
                sx={{ opacity: isMerchantRestricted ? 0.5 : 1 }}
              >
                Delivery Partners
              </MenuItem>
            )}
            <MenuItem
              onClick={() => { if (!isMerchantRestricted) { navigate("/home/weekly_delivery_slots"); dispatch(updatepageName("weekly_delivery_slots")); handleClose(); } }}
              disabled={isMerchantRestricted}
              sx={{ opacity: isMerchantRestricted ? 0.5 : 1 }}
            >
              Weekly Delivery Slots
            </MenuItem>
            {/* <MenuItem 
              onClick={() => { if (!isMerchantRestricted) { navigate("/home/user_management"); dispatch(updatepageName("user_management")); handleClose(); } }}
              disabled={isMerchantRestricted}
              sx={{ opacity: isMerchantRestricted ? 0.5 : 1 }}
            >
              User Management
            </MenuItem> */}
            {/* <MenuItem 
              onClick={() => { if (!isMerchantRestricted) { navigate("/home/offer_management"); dispatch(updatepageName("offer_management")); handleClose(); } }}
              disabled={isMerchantRestricted}
              sx={{ opacity: isMerchantRestricted ? 0.5 : 1 }}
            >
              Offer Management
            </MenuItem> */}
            {canAccessSettings && (
              <>
                <MenuItem
                  onClick={() => { if (!isMerchantRestricted) { navigate("/home/category"); dispatch(updatepageName("category")); handleClose(); } }}
                  disabled={isMerchantRestricted}
                  sx={{ opacity: isMerchantRestricted ? 0.5 : 1 }}
                >
                  Category Settings
                </MenuItem>
                <MenuItem
                  onClick={() => { if (!isMerchantRestricted) { navigate("/home/sub_category"); dispatch(updatepageName("sub_category")); handleClose(); } }}
                  disabled={isMerchantRestricted}
                  sx={{ opacity: isMerchantRestricted ? 0.5 : 1 }}
                >
                  Sub Category Settings
                </MenuItem>
                {user_role !== 'merchant' && (
                  <>
                    <MenuItem
                      onClick={() => { if (!isMerchantRestricted) { navigate("/home/general"); dispatch(updatepageName("general")); handleClose(); } }}
                      disabled={isMerchantRestricted}
                      sx={{ opacity: isMerchantRestricted ? 0.5 : 1 }}
                    >
                      General Settings
                    </MenuItem>
                    {user_role !== 'supervisor' && (
                      <MenuItem
                        onClick={() => { if (!isMerchantRestricted) { navigate("/home/app_version_control"); dispatch(updatepageName("app_version_control")); handleClose(); } }}
                        disabled={isMerchantRestricted}
                        sx={{ opacity: isMerchantRestricted ? 0.5 : 1 }}
                      >
                        App Version Control
                      </MenuItem>
                    )}
                    <MenuItem
                      onClick={() => { if (!isMerchantRestricted) { navigate("/home/addinstruction"); dispatch(updatepageName("addinstruction")); handleClose(); } }}
                      disabled={isMerchantRestricted}
                      sx={{ opacity: isMerchantRestricted ? 0.5 : 1 }}
                    >
                      Instruction Management
                    </MenuItem>
                  </>
                )}
              </>
            )}
            <MenuItem
              onClick={() => { if (!isMerchantRestricted) { logout(); } }}
              disabled={isMerchantRestricted}
              sx={{ opacity: isMerchantRestricted ? 0.5 : 1 }}
            >
              Logout
            </MenuItem>
          </Box>
        </Menu>
      </Box>
    </Box>
  );
}
